import { Injectable } from '@angular/core';
import { TableDatasource } from '@core/api/table.datasource';
import { RisikoOpkraevning } from '@features/risikoopkraevning/risiko-opkraevning.model';

@Injectable({
  providedIn: 'root',
})
export class LeverandoerRisikoOpkraevningDatasource extends TableDatasource<
  RisikoOpkraevning,
  LeverandoerRisikoOpkraevningSearchParams
> {
  endpoint = '/api/admin/risikoopkraevninger';
  defaultSortField = 'id';
  override defaultDescending = true;
}

export interface LeverandoerRisikoOpkraevningSearchParams {
  leverandoerOpkraevningId: number;
}
